import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  selector: 'app-modal-error-config',
  templateUrl: './modal-error-config.component.html',
  styleUrls: ['./modal-error-config.component.scss'],
  imports: [CommonModule, I18NextModule, MatDialogModule]
})
export class ModalErrorConfigComponent {
  constructor(public dialogRef: MatDialogRef<ModalErrorConfigComponent>) {}
}
